import { Fragment } from 'react';
import styled from 'styled-components';
import { Spacing4 } from 'autogen/design-tokens/tokens';
import { Typography } from 'components/generic/typography';
import WithIcon from 'components/hoc/withIcon/WithIcon';
import Icon from 'components/Icon';
import Flex from 'components/Layout/components/Flex';

type HelpTextType = 'warning' | 'error';
export type HelpText = { type?: HelpTextType; message: string };
export type HelperTextProps = HelpText | HelpText[];

const WarningText = styled(Typography.Body)`
    color: ${({ theme }) => theme.ColorTextWarning};
`;

const ErrorText = styled(Typography.Body)`
    color: ${({ theme }) => theme.ColorTextError};
`;
const Text = styled(Typography.Body)`
    color: ${({ theme }) => theme.ColorTextSecondary};
`;

const WarningIcon = styled(Icon)`
    fill: ${({ theme }) => theme.ColorIconWarning};
`;

const ErrorIcon = styled(Icon)`
    fill: ${({ theme }) => theme.ColorIconError};
`;

const StyledWithIcon = styled(WithIcon)`
 align-items: start;
`;

const getTextType = (helperText: HelpText) => {
    switch (helperText.type) {
        case 'error':
            return (
                <StyledWithIcon spacing={Spacing4} icon={<ErrorIcon type="Error" size={16} />}>
                    <ErrorText size="S">{helperText.message}</ErrorText>
                </StyledWithIcon>
            );
        case 'warning':
            return (
                <StyledWithIcon spacing={Spacing4} icon={<WarningIcon type="Alert" size={16} />}>
                    <WarningText size="S">{helperText.message}</WarningText>
                </StyledWithIcon>
            );
        default:
            return <Text size="S">{helperText.message}</Text>;
    }
};

export default function HelperText({
    helperText,
    helperTextId
}: {
    helperText: HelperTextProps;
    helperTextId: string;
}) {
    return (
        <Flex.Column gap={Spacing4} id={helperTextId} justifyContent={'start'}>
            {Array.isArray(helperText)
                ? helperText.map((text, index) => <Fragment key={index}>{getTextType(text)}</Fragment>)
                : getTextType(helperText)}
        </Flex.Column>
    );
}
